import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('../views/dashboard.vue')
    },
    {
        path: '/global-influencer',
        name: 'global-influencer',
        component: () => import('../views/global-influencer.vue')
    },
    {
        path: '/influencer',
        name: 'influencer',
        component: () => import('../views/influencer.vue')
    },
    {
        path: '/full-process',
        name: 'full-process',
        component: () => import('../views/full-process.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/about.vue')
    },
    {
        path: '/form',
        name: 'form',
        component: () => import('../views/form.vue')
    },
    {
        path: '/apply',
        name: 'apply',
        component: () => import('../views/apply-for.vue')
    },
    {
        path: '/policy',
        name: 'policy',
        component: () => import('../views/policy.vue')
    },
    {
        path: '/service',
        name: 'service',
        component: () => import('../views/service.vue')
    },
    {
        path: '/nexalink',
        name: 'nexalink',
        component: () => import('../views/nexalink.vue')
    },
    {
        path: '/deepblue',
        name: 'deepblue',
        component: () => import('../views/deepblue.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 } // 否则滚动到顶部
    }
})

export default router